// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__RFV0l","bannerTextContainer":"banner_bannerTextContainer__a0YfH","bannerText":"banner_bannerText__yuiq1"};